import styled from 'styled-components/macro';

export const CardContent = styled.div`
  padding: ${(props) => props.theme.spacing(20)};
  padding-top: ${(props) => props.theme.spacing(8)};
`;

export const UnderConstructionContainer = styled.div`
  text-align: center;
  height: 54px;
  margin-top: ${(props) => props.theme.spacing(30)};
  font-size: ${(props) => props.theme.typography.sizes.small};
  color: ${(props) => props.theme.palette.custom.formHeader};
  font-weight: 300;
`;
